import { render, staticRenderFns } from "./QCheck.vue?vue&type=template&id=9a42bc52&scoped=true"
import script from "./QCheck.vue?vue&type=script&lang=js"
export * from "./QCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a42bc52",
  null
  
)

export default component.exports